/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (session record) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
export default {
	type: 'object',
	properties: {
		session_type: {
			type: 'string',
			initial: 'xl',
			enum: ['xl', 'regular'],
			enumLabels: ['XL', 'Regular'],
			label: 'Session type',
			kind: 'select',
		},
	},
}
